var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTeamIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#2E117F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups_black_24dp",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2047",
    x: 26.3,
    y: 26.3,
    className: "st0",
    width: 147.5,
    height: 147.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5429",
    transform: "translate(0.304 10.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7763",
    className: "st1",
    d: "M51.3,95.9c6.7,0,12.1-5.4,12.1-12.1c0-6.7-5.4-12.1-12.1-12.1s-12.1,5.4-12.1,12.1 C39.2,90.5,44.6,95.9,51.3,95.9z M58.1,102.6c-2.3-0.4-4.5-0.6-6.8-0.6c-5.8,0-11.5,1.2-16.8,3.5c-4.5,1.9-7.4,6.3-7.4,11.2v9.5 h27.2v-9.8C54.3,111.5,55.6,106.8,58.1,102.6z M148.1,95.9c6.7,0,12.1-5.4,12.1-12.1c0-6.7-5.4-12.1-12.1-12.1 c-6.7,0-12.1,5.4-12.1,12.1C136,90.5,141.4,95.9,148.1,95.9L148.1,95.9z M172.3,116.7c0-4.9-2.9-9.3-7.4-11.2 c-7.4-3.3-15.7-4.3-23.7-2.9c2.5,4.2,3.8,9,3.8,13.9v9.8h27.2L172.3,116.7z M125.4,99.8c-8.1-3.6-16.8-5.4-25.6-5.4 c-8.8,0-17.6,1.9-25.7,5.4c-6.5,2.9-10.7,9.4-10.7,16.6v9.7H136v-9.8C136.1,109.3,131.9,102.8,125.4,99.8z M75.9,114.1 c0.5-1.4,0.8-2.4,5.5-4.2c11.8-4.5,24.8-4.5,36.6,0c4.7,1.8,4.9,2.8,5.5,4.2H75.9z M99.7,65.6c3.3,0,6.1,2.7,6.1,6.1 s-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1C93.7,68.4,96.4,65.7,99.7,65.6 M99.7,53.5c-10,0-18.2,8.1-18.2,18.2s8.1,18.2,18.2,18.2 s18.2-8.1,18.2-18.2C117.9,61.7,109.8,53.6,99.7,53.5C99.7,53.5,99.7,53.5,99.7,53.5z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon01);
export default __webpack_public_path__ + "static/media/team-icon-01.a5310ac97a0a9738f9de264675d96978.svg";
export { ForwardRef as ReactComponent };